import { DialogController } from "../controller/dialogController";
import { MainController } from "../controller/mainController";
import { GameScene } from "../display/gameScene";
import { ParallaxScene } from "../display/parallaxScene";
import { DialogEvent } from "../events/dialogEvent";
import { Text } from "../display/text";

class Chapter8Scene1 extends GameScene {



    constructor() {
        super("chapter8Scene1");
        this.title = Text.get("c8s1-title");
        this.subtitle = Text.get("c8s1-subtitle");
    } 

    preload ()
    {
        super.preload();
        this.load.image('c8-s1-background', 'assets/images/chapters/chapter8/scene1/background.jpg');
        this.load.image('c8-s1-firstplan', 'assets/images/chapters/chapter8/scene1/firstplan.png');
        this.load.image('c8-s1-secondplan', 'assets/images/chapters/chapter8/scene1/secondplan.png');

        this.load.audio('ambient-secret', 'assets/audios/musics/ambiance-secret.mp3');
        
    }

    create ()
    {
        
        super.create();

        this.setParallaxDistance( ParallaxScene.DISTANCE_NEAR );

        this.background = this.add.image(0,0, 'c8-s1-background');
        this.secondplan = this.add.image(0, 611, 'c8-s1-secondplan');
        this.firstplan = this.add.image(361, 421, 'c8-s1-firstplan');


        this.musicAudio = this.sound.add(
                'ambient-secret', 
                {
                    volume: 0.5,
                    loop: true
                });

        this.musicAudio.play();

        this.addToScene( this.background, 3 );
        this.addToScene( this.secondplan, 2 );
        this.addToScene( this.firstplan, 1 );

        this.timerStart = this.time.delayedCall(5000, function(){
            
            this.firstDialog();

        }, [], this);
    

        MainController.setCurrentScene( this );


    }

    firstDialog()
    {
        this.dialog("weston", Text.get("c8s1-dialog1"));
        this.dialog("myriam", Text.get("c8s1-dialog2"));
        this.dialog("weston", Text.get("c8s1-dialog3"));
        this.dialog("myriam", Text.get("c8s1-dialog4"));
        this.dialog("theo", Text.get("c8s1-dialog5"));
        this.dialog("myriam", Text.get("c8s1-dialog6"));
        this.dialog("weston", Text.get("c8s1-dialog7"));
        this.quizUniqueChoice("theo", Text.get("c8s1-dialog8"),
            [
                {
                    "id": "q1-choice1",
                    "label": Text.get("c8s1-dialog9"),
                    "value": 0
                },
                {
                    "id": "q1-choice2",
                    "label": Text.get("c8s1-dialog10"),
                    "value": 1
                }
            ],
            function(result){
                DialogController.DisplayNext(); // je le force le futur dialog à apparaitre sans passer par l'étape bouton à cliquer
                
                if(result[0].value == 1)
                {
                    this.scene.secondDialog();
                }else
                {
                    this.scene.dialog("weston", Text.get("c8s1-dialog11"));
                    this.scene.dialog("theo", Text.get("c8s1-dialog12"));
                    this.scene.dialog("weston", Text.get("c8s1-dialog13"));
                    this.scene.secondDialog();
                }
            },
            null,
            this
        );
    }

    secondDialog()
    {
        this.dialog("weston", Text.get("c8s1-dialog14"));
        this.dialog("myriam", Text.get("c8s1-dialog15"));
        this.dialog("weston", Text.get("c8s1-dialog16"), function(scene){
            scene.endDialog();
        }, this);
    }

    endDialog()
    {

        this.endDialListener = window.addEventListener( DialogEvent.CLOSE, function handler(){
            this.removeEventListener(DialogEvent.CLOSE, handler);
            var scene = MainController.getCurrentScene();

            scene.goToScene('chapter8Scene2');
        });
        
    }

    beforeTransition()
    {
        
        this.tweens.add({
            targets:  this.musicAudio,
            volume:   0,
            duration: 1000
        });

    } 

    beforeDestroy()
    {
        this.musicAudio.destroy();
    }


}
export {Chapter8Scene1}